import React from "react";
import ReactDOM from "react-dom";

import { Routes } from "./main/Routes";

ReactDOM.render(
  <React.StrictMode>
    <Routes />
  </React.StrictMode>,
  document.getElementById("root")
);
